/*
===============================================================================================================
                                 Copyright 2023-2026, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import { isGiftReturnsEnabled } from '@/utilities/refunds';

const isPassesRules = (route, portalConfig, isReturnMethodsEnabled) => {
  if (!route.condition) return true;

  const routeForNonIntegrated = route.condition === 'isNonIntegrated';
  const routForIntegrated = route.condition === 'isIntegrated';
  const canCreateTestOrders = route.condition === 'canCreateTestOrders';
  const isReturnMethodsCondition = route.condition === 'canViewReturnMethods';
  const hasRefundsEnabled = route.condition === 'hasRefundsEnabled';
  const hasGiftReturnsEnabled = route.condition === 'hasGiftReturnsEnabled';

  if (hasRefundsEnabled && !portalConfig?.refunds?.enabled) return false;
  if (hasGiftReturnsEnabled && !isGiftReturnsEnabled({
    giftReturnsFeatureEnabled: portalConfig?.features?.giftReturns?.enabled,
    refundMethodRules: portalConfig?.rulesConfig?.filter((r) => r.ruleType === 'refundMethod'),
  })) return false;
  if (routeForNonIntegrated && portalConfig.isIntegrated) return false;
  if (routForIntegrated && !portalConfig.isIntegrated) return false;
  if (isReturnMethodsCondition && !isReturnMethodsEnabled) return false;
  return !(canCreateTestOrders && !portalConfig.canCreateOrdersDirectly);
};

export default function getNavigationRoutes(portalConfig, isReturnMethodsEnabled) {
  const navRoute = portalConfig.features?.navigation;
  const routes = navRoute?.pages || navRoute || [];
  const filteredRoutes = routes.filter((route) => isPassesRules(route, portalConfig, isReturnMethodsEnabled));
  return filteredRoutes.map((route) => {
    if (route.subItems) {
      return {
        ...route,
        subItems: route.subItems.filter((subItem) => isPassesRules(subItem, portalConfig, isReturnMethodsEnabled)),
      };
    }
    return route;
  });
}
